module.exports = __webpack_public_path__ + "static/signatures-6dadf96d9a692aff669f2e1b5f9581ae.png";